import { TextField } from "@mui/material";

export const Input = ({type,placeholder,sx,...rest }) => {
     return <TextField type={type} placeholder={placeholder} sx={sx} {...rest}/>
}